<div class="container-fluid py-5">
  <app-delinquency-report
    [title]="'FRT Delinquency Report'"
    [delinquencyReportColDefs]="FRTDelinquencyReportGridColumnDefs"
    [delinquencyReportData]="FRTDelinquencyReportVM$"
  ></app-delinquency-report>
</div>
